import type { AxiosError } from 'axios';
import useSWR from 'swr';

import type { SimplePrice } from 'src/types/coinGecko';
import { get } from 'src/utils/axios';

export function useCoinGeckoPriceSWR(suspense?: boolean) {
  const requestURL = `https://api.coingecko.com/api/v3/simple/price?vs_currencies=usd&ids=dydx,ethereum&include_market_cap=true&include_24hr_change=true`;

  const fetcher = (fetchUrl: string) => get<SimplePrice>(fetchUrl);

  const { data, error, mutate } = useSWR<SimplePrice, AxiosError>(requestURL, fetcher, {
    dedupingInterval: 14000,
    refreshInterval: 15000,
    errorRetryCount: 3,
    errorRetryInterval: 5000,
    suspense,
  });

  return { data, error, mutate };
}
